import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import axios from 'axios'
import Backdrop from '../../common/components/UI/Backdrop/Backdrop';
import SimpleDialog from '../../common/components/UI/Dialog/SimpleDialog';
import Snackbar from '../../common/components/UI/Snackbar/Snackbar';
import Form from './Form/form'
import { workplanSettingIndex } from '../styles/settingsStyle'
import { currentHttpOptions } from '../../common/utilities/utilitiesFunctions';
import { Drawer, Button } from 'rsuite';
import "rsuite/dist/rsuite.min.css";
import "./index.scss";
import AdminTable from './AdminTable/AdminTable';
import { stateMapping, mapHyperFindLabelToSettings, mapNotificationToSettings, handleSearchFilter } from './index.service';
import AppBar from '../../common/components/UI/AppBar';
import AppBarContent from '../../common/components/UI/AppBarContent';
import GlobalSetup from '../components/GlobalSetup';
import * as aux from '../auxilaries';
import { ScheduleTagType } from '../Enums';

const styles = theme => (workplanSettingIndex(theme));

class WPSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...stateMapping,
            currentView: props.initialView === 'GlobalSetup' ? 'globalSetup' : 'dashboard'
        };
        this.init();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialView !== this.props.initialView) {
            this.setState({
                currentView: this.props.initialView === 'GlobalSetup' ? 'globalSetup' : 'dashboard'
            });
        }
    }

    init = async () => {

        let [allSettings, allData, allNotifications, scheduleTags] = await Promise.all([
            axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetSettingsForAdmin', currentHttpOptions()),
            axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/Workplan/GetUkgItems', currentHttpOptions()),
            axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetGenericNotificationList', currentHttpOptions()),
            axios.get(`${process.env.REACT_APP_DOTNET_URL}/api/v1/admin/GetScheduleTags/${ScheduleTagType.Schedule}`, currentHttpOptions())
        ])

        const settingList = mapHyperFindLabelToSettings(allSettings, allData);
        const notificationList = mapNotificationToSettings(allNotifications);
        const scheduleTagOptions = (scheduleTags.data || []).map(tag => ({ value: tag.id, label: tag.name }));

        this.setState({
            settingList,
            filteredSettingList: settingList,
            data: { ...allData.data, scheduleTags: scheduleTagOptions },
            notificationList: notificationList,
            displaySpinner: false
        })
    }


    handleSubmitForm = async form => {
        const { t } = this.props;
        const { sideAction } = this.state;
        this.displaySpinner(true);

        try {
            const creationResponse = await this.createForm(form)
            let errorMessage = aux.handleAPIErrors(creationResponse);
            if (errorMessage) {
                throw new Error(errorMessage)
            }
            else {
                let responseStatusText = sideAction === 'Edit' ? t('settings.settingEditSuccess') : t('settings.settingSuccess')
                this.setState({
                    openForm: false,
                    responseStatus: 'success',
                    showResponseDialog: true,
                    responseStatusText: responseStatusText,
                    settingSelected: {},
                    selectedItem: {}
                })
            }

        } catch (err) {
            let errorMessage = aux.handleAPIErrors(err.response)
            this.setState({
                openForm: false,
                responseStatus: 'error',
                settingSelected: {},
                selectedItem: {},
                showResponseDialog: true,
                responseStatusText: errorMessage || 'An error has occured',
            })

        }

        this.displaySpinner(false);
        this.init();
    }

    createForm = async (form) => {
        if (this.state.sideAction === 'Edit') {
            return await axios.put(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/UpdateAdminSetting/' + this.state.settingSelected.id, form, currentHttpOptions())
        } else {
            return await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/CreateAdminSetting', form, currentHttpOptions())
        }
    }

    cancelAction = () => {
        this.setState({
            openForm: false,
            showDeleteDialog: false,
            sideAction: '',
            spinnerShow: false,
            dataviewColumns: [],
            settingSelected: {}
        })
    }

    rightPanelHandler = async (sideAction, selectedItem) => {
        if (sideAction === 'Delete') {
            this.setState({
                showDeleteDialog: true,
                sideAction,
                settingSelected: selectedItem,
            })
        } else {
            this.displaySpinner(true)
            let auxAdminSetting = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetSettingDetailsForAdmin/' + selectedItem.id, currentHttpOptions());
            let dataviewColumns = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetDataviewColumns/' + auxAdminSetting.data.columnSet.dataview, currentHttpOptions());


            this.setState({
                sideAction,
                settingSelected: auxAdminSetting.data,
                dataviewColumns: dataviewColumns.data.map(column => { return { ...column, id: column.value } }),
                openForm: true,
                displaySpinner: false
            })
        }
    }

    deleteItem = async () => {
        const { t } = this.props;
        const { settingSelected, settingList, filteredSettingList } = this.state
        this.displaySpinner(true)
        this.cancelAction()

        try {
            const response = await axios.delete(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/DeleteAdminSetting/' + settingSelected.id, currentHttpOptions());
            let errorMessage = aux.handleAPIErrors(response);
            if (errorMessage) {
                throw new Error(errorMessage)
            } else {

                let settingListAux = settingList.filter((element) => element.id !== settingSelected.id)
                let filteredSettingListAux = filteredSettingList.filter((element) => element.id !== settingSelected.id)

                this.setState({
                    settingList: settingListAux,
                    filteredSettingList: filteredSettingListAux,
                    responseStatus: 'success',
                    showResponseDialog: true,
                    responseStatusText: t('settings.deleteSuccess'),
                    settingSelected: {},
                })
            }
        } catch (err) {
            let errorMessage = aux.handleAPIErrors(err.response)
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: errorMessage || "An error has occured",
                settingSelected: {},
                settingList: settingList,
                filteredSettingList: filteredSettingList,
            })
        }

        this.displaySpinner(false)
    }

    handleStatePropChange = (propName, prop) => this.setState(prevState => ({ ...prevState, [propName]: prop }));
    handleSearch = (value) => handleSearchFilter(value, this.state.settingList, this.handleStatePropChange);
    handleCreateNewSetting = () => this.setState({ displaySpinner: true, sideAction: 'new', openForm: true })
    displaySpinner = (displaySpinner) => { this.setState({ displaySpinner }) };
    handleViewChange = (view) => this.setState({ currentView: view });

    render() {
        const { classes, t } = this.props;
        const { openForm, settingSelected, filteredSettingList, showResponseDialog, responseStatus, responseStatusText,
            showDeleteDialog, displaySpinner, data, settingList, dataviewColumns, sideAction, notificationList, currentView } = this.state;

        let deleteString = t('settings.deleteContent')
        const pageName = currentView === 'globalSetup' ? t('settings.appNameGlobalSetup') : t('settings.appNameAdminDashboard');

        return (
            <section className={classes.content}>
                <AppBar>
                    <AppBarContent
                        name={t('settings.appName')}
                        pageName={pageName}
                    />
                </AppBar>
                {currentView === 'dashboard' && (
                    <AdminTable
                        handleCreateNewSetting={this.handleCreateNewSetting}
                        handleSearchFilter={this.handleSearch}
                        options={filteredSettingList}
                        handleEdit={(item) => this.rightPanelHandler('Edit', item)}
                        handleDuplicate={(item) => this.rightPanelHandler('Duplicate', item)}
                        handleDelete={(item) => this.rightPanelHandler('Delete', item)}
                    />
                )}
                {currentView === 'globalSetup' && (
                    <GlobalSetup />
                )}
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <SimpleDialog
                    open={showDeleteDialog}
                    title={t('settings.delete')}
                    contentText={deleteString}
                    submit={this.deleteItem}
                    cancel={this.cancelAction}
                />
                {showResponseDialog ? (
                    <Snackbar
                        type={responseStatus}
                        message={responseStatusText}
                        open={showResponseDialog}
                        closeSnackbar={() => { this.setState({ showResponseDialog: false }) }}
                        bodyStyle={{ whiteSpace: 'pre-line' }}
                    />) : ''}
                <Drawer
                    open={openForm}
                    className="notification-modal"
                    size="lg"
                    backdrop="static"
                >
                    <Drawer.Title className="drawer-title" >
                        <div >{t("workplanManager:settings.editDrawerTitle")}</div>
                        <Button onClick={this.cancelAction}> X </Button>
                    </Drawer.Title>
                    <Drawer.Body className="modal-body">
                        <Form
                            settingList={settingList}
                            settingSelected={settingSelected}
                            notificationList={notificationList}
                            data={data}
                            dataviewColumns={dataviewColumns}
                            cancel={this.cancelAction}
                            handleSubmitForm={this.handleSubmitForm}
                            displaySpinner={this.displaySpinner}
                            action={sideAction}
                        />
                    </Drawer.Body>
                </Drawer>
            </section>
        );
    }
}

export default withStyles(styles)(translate(['workplanManager'])(WPSettings));